import { component } from 'picoapp'

export default component((node, ctx) => {

  const termNode = node.querySelector('#Terms');

  let btnSubmit = node.querySelector('input[type="submit"]');


  if (termNode) {
    termNode.addEventListener('change', (e) => {
      btnSubmit.value === 'Out of Stock' ? '' : btnSubmit.disabled = !termNode.checked
    })
  }

});